import styled from 'styled-components';
import { H1Text } from '@prisjakt/ui/text/variants';
import { layout, media } from '@prisjakt/ui-base';

export const Header = styled.header`
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing050};
  padding: 0 ${layout.measurements.spacing050};

  ${media.mediumDown`
    margin-top: ${layout.measurements.spacing050};
  `}
`;

export const Title = styled(H1Text)`
  &::first-letter {
    text-transform: uppercase;
  }

  && {
    ${media.smallOnly`
      font-size: 1.5rem;
    `};
  }
`;

export const Description = styled.div`
  max-width: 36em;
`;
